(function ($) {
	$.smoothScroll = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			SmoothScroll = (function ($c, o) {
				var defaults = {

				}; 

				var _o = {},

					hh = 0, // Header Height
					$h = null // Header
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					$h = $('.main-header');
					_GetMeasurements();
				},

					_GetMeasurements = function() {
						hh = $h.height();
					},

				_BindEvents = function () {
					$c.click(_OnLinkClick);
					$(window).resize(_OnWindowResize);
				},

					_OnLinkClick = function(e) {
						e.preventDefault();

						var $$ = $(e.currentTarget),
							$a = $('> a', $$);

						if ($a.length > 0) {
							$$ = $a.first();
						}

						var t = $$.prop('hash'),
							$t = $(t),
							sd = $$.data('smooth-delay') || 0;

						setTimeout(function() {
							$('html, body').animate({
								scrollTop: $t.offset().top - (hh - 1)
							}, 500);
						}, sd);
					},

					_OnWindowResize = function(e) {
						_GetMeasurements();
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.smoothScroll = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('smoothScroll')) {
				var plugin = new $.smoothScroll(this, options);
				$(this).data('smoothScroll', plugin);
			}
		});
	};
})(jQuery);
